import { api, guard, unwrap } from './client'

/**
 * Credits: what this account holds, what it has spent, and checkout payments.
 */
export const billingApi = {
  balance: () => guard(async () => unwrap(await api.GET('/api/billing/balance'))),
  transactions: (limit = 20) =>
    guard(async () =>
      unwrap(await api.GET('/api/billing/transactions', { params: { query: { limit } } })),
    ),
  createOrder: (package_id: string) =>
    guard(async () =>
      unwrap(
        await api.POST('/api/billing/razorpay/orders', {
          body: { package_id },
        }),
      ),
    ),
  verifyPayment: (data: {
    razorpay_order_id: string
    razorpay_payment_id: string
    razorpay_signature: string
  }) =>
    guard(async () =>
      unwrap(
        await api.POST('/api/billing/razorpay/verify', {
          body: data,
        }),
      ),
    ),
  payments: (limit = 50, offset = 0) =>
    guard(async () =>
      unwrap(
        await api.GET('/api/billing/payments', {
          params: { query: { limit, offset } },
        }),
      ),
    ),
}
